import "./styles.css";
// import "./ui/app.ts"; // Disable old 2D UI for now
import { mountSpatialOS } from "./SpatialRoot";

const appRoot = document.getElementById("app") || document.body;
// Try to clean existing content if any
appRoot.innerHTML = "";
// Create a container if needed or just mount to body
const container = document.createElement("div");
container.id = "spatial-root";
container.style.width = "100vw";
container.style.height = "100vh";
appRoot.appendChild(container);

mountSpatialOS(container);
